<template>
    <v-dialog
        v-model="currentOpen"
        :class="[single ? 'is-single' : '']"
        class="v-staff-select-dialog"
        @hide="handleCancel"
    >
        <v-tip
            ref="add"
            placement="top"
        >
            <span>添加所有成员</span>
        </v-tip>

        <v-tip
            ref="tip"
            placement="top"
        >
            <span>未设置软电话权限，请至管理-客户端添加。</span>
        </v-tip>

        <v-tip
            ref="tipun"
            placement="top"
        >
            <span>该员工已失效</span>
        </v-tip>

        <VmSelectBusiness
            v-if="currentOpen"
            :key="vmSelectKey"
            :config="config"
            :hooks="hooks"
            @submit="handleConfirm"
            @cancel="handleCancel"
        />
    </v-dialog>
</template>

<script>
/* eslint-disable */
import VmSelectBusiness from '@/components/vm-select-business-v2';
import {
    Dialog as VDialog,
    Button as VButton,
    Spinner as VSpinner,
    Tip as VTip,
    Icon as VIcon,
    Tree as VTree
} from 'vhtml-ui';
import SearchList from './search-list';

const req = require.context('./assets/icons', false, /[^\.]+\.svg$/);
VIcon.addSprites(req);

/**
 * 该组件，在部门下直接选择的数据和通过搜索得到的数据输出的数据格式不同，导致使用的时候因为用法问题产生了一定的问题，将会在分组沉淀需求上线后修复这个问题，并提供一个数据输出文档
 * 现在临时在业务组件中修复这个问题 @feiyugao
 */

export default {
    name: 'StaffSelectDialog',
    components: {
        VmSelectBusiness,
        VDialog,
        VButton,
        VSpinner,
        VIcon,
        VTip,
        VTree,
        SearchList
    },
    model: {
        prop: 'open',
        event: 'input'
    },
    props: {
        init: {
            type: Boolean,
            default: false
        },
        open: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Array,
            default() {
                return [];
            }
        },
        single: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '选择员工'
        },
        titleSelected: {
            type: String,
            default: '已选员工'
        },
        subtitle: {
            type: String,
            default: '选择监控对象'
        },
        openType: {
            type: String,
            default: 'clean' // 'clean' 每次打开清空 / 'keep' 保持传入的selected
        },

        // 是否可以选中部门
        departCanSelect: {
            type: Boolean,
            default: false
        },

        // 之前已经选中了的 跟selected同样不能选中，区别是显示样式不一样，并且不在右侧列表展示不可反选
        hisSelected: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            loading: false,
            scrolling: false,
            fetchInitDataError: false,
            currentInit: this.init,
            currentOpen: this.open,
            currentOptions: [],
            currentSelected: [...this.selected],
            keywords: '',
            searching: false,
            scrollWidth: this.getScrollWidth(),
            vmSelectKey: `vsk${Date.now()}`,
            maps: {
                value: 'id',
                hasChildren: 'isParent'
            },
            folderSelectedMap: {},
            userList: [],
            departNum: 0
        };
    },
    watch: {
        currentInit(val) {
            if (val) {
                this.loading = false;
                this.fetchInitData();
                // 重复的180925注释观察 @feiyugao
                // this.getTreeData();
                if (this.openType == 'clean') {
                    this.currentSelected = [];
                }
                val = false;
            }
        },
        open(nextValue) {
            this.currentInit = nextValue;
            this.currentOpen = nextValue;
            this.keywords = '';

            this.currentSelected = [...this.selected];
        },
        currentOpen(nextValue) {
            this.$emit('input', nextValue);
        },
        selected(nextValue) {
            console.log('我是选中数据', nextValue);
            this.currentSelected = [...nextValue];
        },

        currentSelected(val) {
            if (this.departCanSelect) {
                this.folderSelectedMap = {};
                val.forEach(v => {
                    if (v.isFolder) {
                        this.folderSelectedMap[v.id] = true;
                    }
                });
            }
            val.forEach(item => {
                if (!item.isFolder) {
                    this.userList.push(item);
                    return this.userList;
                }
            });

            this.departNum = 0;
            val.forEach(item => {
                this.departNum += item.total ? new Number(item.total) : 0;
            });
            this.departNum += this.userList.length;
            this.userList = [];
        }
    },
    computed: {
        config() {
            return {
                tabs: {
                    // 同事数据源标识
                    colleague: {
                        selected: this.selected ? this.selected : [], // 默认已选id
                        checkStrictly: true, // 严格模式，父子不相关,
                        reqOptions: {}, // orgtree 的请求参数扩展
                        folderCanSelect: true,
                        deptNodeOnly: false // 仅展示部门节点
                    }
                },
                multiple: !this.single, // 多选/单选
                maxLength: 0, // 最大可选数 ，0 表示不限制,
                layout: {
                    search: true, // 是否展示搜索，默认true
                    list: true, // 是否展示列表 默认true
                    status: true, // 是否展示已选数。默认 true
                    action: true, // 是否展示 “确认/取消” 。默认 true
                    action:{
                        selectAll: false, // 是否展示 全选/取消
                        btn:true // 提交按钮是否展示
                    },
                    selected: true // 是否展示已选列表， 默认true
                },
                withCheckbox: false, // 是否展示checkbox
            }
        },
        hooks() {
            return {
                colleague: { // 数据源类型
					// 构建节点的事件，
                    onNodeBuild: (node) => {
                        if (node.data.disabled) {
                            node.data.tips = '未设置软电话权限，请至管理-客户端添加。'
                        }
                        return node;
                    },
                }
            };
        },
    },
    mounted() {
        // this.fetchInitData();
        // this.$refs.treeWrapper.onscroll = () => {
        //     this.scrolling = true;
        // };
    },
    methods: {
        fetchInitData() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            this.getTreeData()
                .then(res => {
                    // console.log(res);
                    this.fetchInitDataError = false;
                    this.loading = false;
                    console.log(res);
                    console.log(this.selected);
                    this.currentSelected = this.selected;
                    this.currentOptions = res.list || [];
                    this.currentOptions.forEach(item => {
                        item.select = false;
                    });
                    // if (this.currentOptions.length === 1) {
                    //     this.$nextTick(() => {
                    //         this.$refs.tree.expand(0);
                    //     });
                    // }
                })
                .catch(() => {
                    this.fetchInitDataError = true;
                    this.loading = false;
                });
        },
        /* mouseenter($vm) {
            // 此函数会导致expand状态不对，目前看并没有使用，先注释
            if (this.single) {
                return;
            }

            this.scrolling = false;
            $vm.$set($vm.options, '_top_', $vm.$el.offsetTop - this.$refs.treeWrapper.scrollTop);
        }, */
        getScrollWidth() {
            let noScroll;
            let scroll;
            const oDiv = document.createElement('DIV');
            oDiv.style.cssText = 'position:absolute; visibility:hidden; width:30px;';
            noScroll = document.body.appendChild(oDiv).clientWidth;
            oDiv.style.overflowY = 'scroll';
            scroll = oDiv.clientWidth;
            document.body.removeChild(oDiv);
            return noScroll - scroll;
        },
        /* 暂时不需要按部门添加
        addAllMembers($vm) {

            let orgId = $vm.options.orgId;
            $vm.subFetching = true;
            this.$ajax.get('/call/settings/receptiongroup/addOrgUsers', {
                params: {
                    orgId: orgId
                }
            })
                .then((res) => {
                    let records = res.data.records || [];
                    records.length && this.$refs.tree.addSelected(records);
                    res.total > 100 && this.$message.error('每次最多添加100人');
                    $vm.subFetching = false;
                })
                .catch((res) => {
                    this.$message.error(res.message || '获取数据失败');
                    $vm.subFetching = false;
                });
        },
        */
        handleConfirm() {
            this.currentOpen = false;
            this.$emit('select', [...this.currentSelected]);
        },
        handleCancel() {
            this.currentOpen = false;
            this.currentSelected = [...this.selected];
        },
        selectedChange(selected, type) {
            console.log('selectedChange');
            console.log(selected);
            this.currentSelected = [...selected];
            let depart = [];
            let userList = [];
            this.currentSelected.forEach(item => {
                if (item.isFolder == true) {
                    depart.push(item);
                } else {
                    userList.push(item);
                }
            });
            console.log(depart);
            this.currentSelected = depart.concat(userList);
            !this.single &&
                type === 'add' &&
                this.$nextTick(() => {
                    this.$refs.selectedBody.scrollTop = 999999999;
                });
        },
        selectNum() {},
        removeSelected(e) {
            console.log(e);
            const id = e.currentTarget.getAttribute('id');
            console.log(id);
            console.log(id.substr(1));
            this.$refs.tree.removeSelected(id);
            console.log(this.currentOptions);
            this.currentOptions[0].children.forEach(item => {
                if (id == item.id || id.substr(1) == item.id) {
                    item.select = false;
                }
                if (item.children) {
                    item.children.forEach(staff => {
                        if (id == staff.id) {
                            staff.select = false;
                        }
                    });
                }
            });

            console.log('揍我了嘛');
        },
        syncTree($vm) {
            const orgId = $vm.options.id;
            this.getTreeData(orgId)
                .then(res => {
                    const records = res.list || [{}];
                    $vm.addChild(records);
                    $vm.hideLoading();
                    $vm.setSynced();
                })
                .catch(res => {
                    $vm.hideLoading();
                    $vm.expand = false;
                });
        },
        getTreeData(orgId) {
            // let defer = this.$ajax.get('/call/settings/receptiongroup/orgAndUsers', {
            const defer = this.$ajax.get('/mng/org/getOrgAndUserTreeNodes', {
                hold: !orgId,
                params: {
                    id: orgId || 0
                }
            });
            defer.catch(res => {
                this.$message.error(res.message || '获取数据失败');
            });

            return defer;
        },
        search() {
            this.searching = !!this.keywords;
            this.searching && this.$refs.search.fetch();
        },
        handleItemClick(vm) {
            console.log(vm, '我是vm');
            vm.options.select = !vm.options.select;
            if (!this.departCanSelect) {
                vm.onItemClicked();
            } else if (vm.isFolder) {
                const vmInfo = {
                    id: `${vm.options.id}`,
                    name: vm.options.name,
                    isFolder: true,
                    total: vm.options.total
                };

                const selected = !this.folderSelectedMap[vmInfo.id];
                console.log(selected);
                if (selected) {
                    this.$refs.tree.addSelected([vmInfo]);
                } else {
                    this.$refs.tree.removeSelected(vmInfo.id);
                }

                this.$refs.tree.emitChangeEvent();
            } else {
                vm.changeCheckState(undefined, true);
            }
            console.log(this.departCanSelect);
        },
        handleSwitchClick(vm) {
            vm.onItemClicked();
        },
        getItemIco(opt) {
            let icoName = '';
            if (opt.isFolder || opt.isParent) {
                icoName = 'department';
            } else if (opt.gender == 1) {
                icoName = 'male';
            } else {
                icoName = 'female';
            }

            if (this.isHisSelected(opt)) {
                icoName += '-selected';
            }
            if (opt.select) {
                icoName += '-selected';
            }
            return icoName;
        },
        getItemIcon(opt) {
            let icoName = '';
            if (opt.isFolder || opt.isParent) {
                icoName = 'department';
            } else if (opt.gender == 1) {
                icoName = 'male';
            } else {
                icoName = 'female';
            }

            if (this.isHisSelected(opt)) {
                icoName += '-selected';
            }
            return icoName;
        },

        isHisSelected(opt) {
            for (let i = 0, len = this.currentSelected.length; i < len; i++) {
                if (opt.id == this.currentSelected[i].id || opt.id == this.currentSelected[i].id.substr(1)) {
                    return true;
                }
            }
            return false;
        },

        handleConfirm({ colleague }) {
            const selectList = colleague ? colleague : [];
            selectList.forEach( v => {
                if (!v.hasOwnProperty('isFolder')) {
                    v.isParent ? v.isFolder = true : v.isFolder = false
                }
            })
            this.$emit('select', selectList);
            this.currentOpen = false;
        },

        handleCancel() {
            this.currentOpen = false;
        },
    }
};
</script>

<style lang="less">
.v-staff-select-dialog {
    // .v-dialog__container {
        // height: 0px;
        // margin-bottom: 40%;
    // }
    .v-dialog__title {
        height: 0;
    }

    .v-dialog__body {
        margin-top: 0;
    }

    &.is-single {
        .v-dialog__content {
            width: 450px;
        }

        .v-input--search {
            width: 400px;
        }

        .v-staff-select-dialog-tree-bd,
        .v-staff-select-dialog-tree-list {
            width: 398px;
        }

        .v-staff-select-dialog-tree-list,
        .v-staff-select-dialog-tree-bd {
            height: 374px;
        }
    }

    .v-dialog__content {
        width: 640px;
        padding-bottom: 0;
    }

    .v-dialog__body {
        padding: 0 20px;
        height: 420px;
        text-align: left;
        .qd-business-selecter {
            padding-right: 0;
            padding-left: 0;
        }

        h2 {
            padding-bottom: 10px;
            font-size: 14px;
            color: #1e2330;
            line-height: 1;

            span {
                margin-left: 3px;
                color: #a8abb3;
            }
        }
        .v-dialog__body--left {
            height: 420px;
        }
        .qd-org-tree{
            width: auto !important;
            height: 316px !important;
        }
    }

    .v-input--search {
        position: relative;
        width: 280px;
        text-align: left;
        z-index: 1;
    }

    &-bd {
        position: relative;
    }

    .arrow {
        margin: 200px 0 0 3px;
        width: 17px;
        height: 17px;
        color: #a8abb3;
    }

    &-tree {
        float: left;

        &-bd {
            position: relative;
            overflow: hidden;
            margin-top: -1px;
            width: 278px;
            height: 349px;
            border: 1px solid #dadee7;

            .v-spinner {
                position: absolute;
                top: 40%;
                left: 50%;
                margin: -10px 0 0 -10px;
            }

            .refresh {
                position: absolute;
                top: 45%;
                left: 0;
                width: 100%;
                text-align: center;
            }

            .v-tree {
                float: left;
                min-width: 100%;

                .v-tree__button {
                    vertical-align: 0;
                }
            }
        }

        &-list {
            overflow: auto;
            width: 278px;
            height: 349px;
        }
    }

    &-selected {
        float: right;
        user-select: none;

        &-bd {
            overflow: auto;
            width: 278px;
            height: 388px;
            border: 1px solid #dadee7;

            li {
                position: relative;
                overflow: hidden;
                padding: 0 40px 0 30px;
                text-overflow: ellipsis;
                white-space: nowrap;
                line-height: 35px;
                cursor: default;

                &:hover {
                    background-color: #f5fafe;

                    .v-staff-select-dialog-selected-del {
                        display: block;
                    }
                }

                &.is-disabled {
                    .v-staff-select-dialog-selected-icon,
                    .v-staff-select-dialog-selected-name {
                        opacity: 0.4;
                    }
                }
            }
        }

        &-name {
            margin-right: 4px;
            color: #1e2330;
        }

        &-icon {
            position: absolute;
            top: 8px;
            left: 8px;
            display: block;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;

            &.ico-depart .v-icon {
                width: 16px;
            }
        }

        &-del {
            position: absolute;
            top: 8px;
            right: 10px;
            display: none;
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;

            svg {
                width: 20px;
                height: 20px;
            }
        }
    }

    &-ft-cancel {
        margin-left: 20px;
    }

    .level0 {
        .v-tree__button--feature {
            margin-right: 5px;
        }
    }

    .v-tree__item.is-disabled {
        pointer-events: none;

        &:hover .v-tree__title {
            background: none;
        }

        .v-tree__button--feature,
        .v-tree__name {
            opacity: 0.4;
        }

        .tips {
            pointer-events: auto;
            cursor: default;
        }
    }

    .tips {
        display: inline-block;
        width: 20px;
        height: 20px;
        color: #a8abb3;
        vertical-align: -5px;
        cursor: default;

        * {
            cursor: default;
        }

        svg {
            width: 20px;
            height: 20px;
        }

        &:hover {
            color: #1e2330;
        }
    }

    .v-tree__title {
        &.is-folder {
            padding-left: 15px;
        }

        .add-sel {
            position: absolute;
            top: 0;
            right: 6px;
            display: none;
            padding: 8px;
            width: 20px;
            height: 20px;
            color: #a8abb3;

            &:hover {
                color: #1e2330;
            }

            &.is-loading {
                display: block;
                background-position: center center;
                background-repeat: no-repeat;
                background-image: url(data:image/gif;base64,R0lGODlhEAAQAPIAAMLY8YSx5HOm4Mjc88/g9Ofw+v///wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFCgAGACwAAAAAEAAQAEADMmi6RbWwPRjdAgFQuS3nEKZ9lgJSZmmc6YSu6rsQAyEbgRBQtH3fPWDtJ/TNhrIgkZgAACH5BAUKAAYALAIAAAAHAAUAQAMPaGoQUKQsA2UDM4hABpkJACH5BAUKAAYALAYAAAAHAAUAQAMOWFTW3iAAxSIgg7wXREgAIfkEBQoABgAsCgACAAUABwBAAw9YVNYGASjmICCDuN2CCAkAIfkEBQoABgAsCgAGAAUABwBAAxBoVlQQQCnmoDRkkGuCCEoCACH5BAUKAAYALAYACgAHAAUAQAMPaGpFBQEsA2UrkwwSRJgJACH5BAUKAAYALAIACgAHAAUAQAMOCAHW3oUUxWIJIrxHBkkAIfkEBQoABgAsAAAGAAUABwBAAw8IAdZWpCjmYAkiuN3IIAkAOw==);

                svg {
                    display: none;
                }
            }

            svg {
                width: 20px;
                height: 20px;
            }
        }

        &.is-selected {
            .add-sel {
                background-color: #f5fafe;
            }
        }

        &:hover {
            .add-sel {
                display: block;
                background-color: #f5fafe;
            }
        }

        &.is-fselected {
            background-color: #d3e9ff;
        }

        &.has-selected {
            pointer-events: none;

            .v-icon {
                width: 17px;
            }

            .v-tree__name {
                opacity: 0.4;
            }

            .v-tree__button--switch {
                cursor: pointer;
                pointer-events: auto;
            }
        }

        .ico-depart {
            .v-icon {
                width: 16px;
            }
        }

        .v-tree__button--switch {
            margin-left: -15px;
            vertical-align: middle;
        }

        .v-tree__button--feature {
            text-align: center;
        }
    }

    .v-button--primary {
        margin-left: 340px;
    }
}
</style>
